import ProductType from './productType';

export default ProductType;